import { useQuery, UseQueryOptions } from "@tanstack/react-query"
import { API_Error } from "@/interfaces/api/response/api_response_types"
import { API_Data_Profiles_Response } from "@/interfaces/api/profiles/api_response_types"
import { listProfiles } from "../requests/profiles"

type ProfilesOptions = Omit<
  UseQueryOptions<API_Data_Profiles_Response, API_Error, API_Data_Profiles_Response, ['profiles']>,
  'queryKey' | 'queryFn'
>

export const useProfiles = (options?: ProfilesOptions) => 
  useQuery<API_Data_Profiles_Response, API_Error, API_Data_Profiles_Response, ['profiles']>({
    queryKey: ['profiles'],
    retry: false,
    queryFn: listProfiles,
    ...options
  })